// frontend/src/pages/public/IntakeProcess/IntakeProcessContent.ts

export const intakeProcessHero = {
eyebrow: "For Patients",
title: "How the request process works",
subtitle:
"Clinics review requests based on their current capacity, practice scope, and intake criteria.",
};

export const intakeProcessSteps = {
id: "steps",
title: "5 steps in the request process",
subtitle:
"A simple process designed to save you time and set clear expectations.",
steps: [
{
title: "Search and filter",
description: "Find doctors by location, language, gender, hours, and more.",
iconSrc: "/icons/search.svg",
},
{
title: "Submit a request",
description:
"Fill out a simple request form. No account needed. Do not include urgent symptoms or detailed medical history.",
iconSrc: "/icons/send.svg",
},
{
title: "Clinic reviews",
description:
"The clinic reviews your request based on its current capacity, practice scope, and intake criteria.",
iconSrc: "/icons/review.svg",
},
{
title: "Get status updates",
description: "Receive email updates with a secure link to check your request status.",
iconSrc: "/icons/mail.svg",
},
{
title: "Clinic update and next steps",
description:
"The clinic may invite you for a Meet & Greet, place your request on a waitlist, or be unable to accept your request. If you are invited, the clinic will contact you directly with next steps.",
iconSrc: "/icons/check.svg",
},
],
};

export const intakeProcessRules = {
id: "rules",
title: "Important rules to know",
rules: [
{
title: "One doctor per clinic",
description:
"You can request multiple doctors at different clinics, but only one doctor per clinic at a time.",
iconSrc: "/icons/one.svg",
},
{
title: "Cancel anytime",
description:
"Use the secure link in your email to view or cancel an active request.",
iconSrc: "/icons/cancel.svg",
},
{
title: "No duplicate requests",
description:
"You cannot submit another active request to the same doctor while one is pending.",
iconSrc: "/icons/repeat.svg",
},
{
title: "7-day expiry",
description:
"If the clinic does not take action within 7 days, the request will expire and will no longer be active. You will be notified by email.",
iconSrc: "/icons/clock.svg",
},
],
};

export const intakeProcessFAQ = {
id: "faq",
title: "Common questions",
items: [
{
question: "Does submitting a request guarantee I will be accepted?",
answer:
"No. Submitting a request does not guarantee attachment, an appointment, or acceptance by a clinic. Clinics make their own intake decisions based on their current capacity, practice scope, and intake criteria.",
},
{
question: "What happens if my request is not accepted?",
answer:
"You can continue searching for other participating family doctors who are accepting new patients. A clinic may be unable to accept a request because of its current capacity, practice scope, or intake criteria. You are free to continue searching and submit another request.",
},
{
question: "Can I submit requests to multiple doctors?",
answer:
"Yes. You can submit requests to multiple doctors at different clinics at the same time. You cannot have multiple active requests to doctors within the same clinic. If you become attached to a family doctor, other active requests may be closed.",
},
{
question: "How do I check the status of my request?",
answer:
"You will receive an email with a secure link to check your request status at any time. No account or login is required.",
},
{
question: "What information do I need to submit a request?",
answer:
"You need basic contact information such as your name, email, phone number, and location details needed to route and manage the request. Do not include urgent symptoms, detailed medical history, medical records, lab results, or diagnostic reports in the public request form.",
},
{
question: "What if I have an urgent medical issue?",
answer:
"AcceptingMD is not an emergency service or clinical triage tool. If you have an emergency, call 911 or go to the nearest emergency department. For urgent medical concerns, contact a healthcare provider directly or use appropriate urgent care services.",
},
],
};

export const intakeProcessCtas = {
id: "cta",
title: "Ready to look for a family doctor?",
subtitle: "No account needed. Start searching now.",
primaryCta: { label: "Find a Family Doctor", to: "/public/find-family-doctor" },
secondaryCta: { label: "How It Works", to: "/public/how-it-works" },
};
